export enum LearningChannel {
    MicrosoftTeamsMicromate = 'microsoft-teams-micromate',
    MicrosoftTeamsTaskbase = 'microsoft-teams-taskbase',
    Learn = 'learn',
    WidgetMoodle = 'widget-moodle',
    Slack = 'slack',
    GoogleChat = 'google-chat'
}

export type LearningChannelType = LearningChannel | string;
